function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Logger from '../../../../../wdh-foundation/wdh-logger/wdh-logger';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ConfigurationMgr = /*#__PURE__*/function () {
  function ConfigurationMgr() {
    _classCallCheck(this, ConfigurationMgr);
  }
  return _createClass(ConfigurationMgr, [{
    key: "loadConfiguration",
    value:
    /**
     * Load configuration from a script element
     * @param {Object} element - The script element containing the translation json dictionary
     */
    function loadConfiguration(element) {
      this.configuration = JSON.parse(element.innerHTML);
      if (typeof this.configuration.Error !== 'undefined') {
        Logger.info('Shop initialization stopped due to missging configuration.');
        return;
      }
      if (this.configuration.enabled === false) {
        Logger.info('Shop disabled.');
        return;
      }
      if (localStorage && localStorage.getItem('shopUrl')) {
        var shopUrl = localStorage.getItem('shopUrl');
        Logger.info("Overwritten configuration for shopUrl: ".concat(shopUrl));
        this.configuration.services.shop = shopUrl;
      }
      if (localStorage && localStorage.getItem('telemetry')) {
        var telemetry = localStorage.getItem('telemetry');
        Logger.info("Overwritten configuration for telemetry: ".concat(telemetry));
        this.configuration.services.telemetry = telemetry === 'true';
      }
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.userId = userId;
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return this.userId;
    }
  }, {
    key: "setCustomerGroupId",
    value: function setCustomerGroupId(customerGroupId) {
      this.customerGroupId = customerGroupId;
    }
  }, {
    key: "getCustomerGroupId",
    value: function getCustomerGroupId() {
      return this.customerGroupId;
    }
  }, {
    key: "setUserCanSeePrices",
    value: function setUserCanSeePrices(canSeePrices) {
      this.userCanSeePrices = canSeePrices;
    }
  }, {
    key: "getUserCanSeePrices",
    value: function getUserCanSeePrices() {
      return this.userCanSeePrices === 'true';
    }

    /**
     * parse the JWT token for use in shop.
     * @param token
     * @returns {any}
     */
  }, {
    key: "parseJwt",
    value: function parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  }, {
    key: "setTokenDetails",
    value:
    /**
     * set tokenDetails var
     * @param token
     */
    function setTokenDetails(token) {
      this.tokenDetails = this.parseJwt(token);
    }
    /**
     * get tokenDetails Var
     * @returns {*}
     */
  }, {
    key: "getTokenDetails",
    value: function getTokenDetails() {
      return this.tokenDetails;
    }

    /**
     * Get service endpoint
     */
  }, {
    key: "getShopServiceEndPoint",
    value: function getShopServiceEndPoint() {
      return this.configuration.services.shop;
    }

    /**
       * Get US Orders service endpoint
       */
  }, {
    key: "getUSOrdersServiceEndPoint",
    value: function getUSOrdersServiceEndPoint() {
      return this.configuration.services.usorders;
    }

    /**
       * Get US Customers service endpoint
       */
  }, {
    key: "getUSCustomersServiceEndPoint",
    value: function getUSCustomersServiceEndPoint() {
      return this.configuration.services.uscustomers;
    }

    /**
     * Get feature flags
     */
  }, {
    key: "getFeatureFlags",
    value: function getFeatureFlags() {
      return this.configuration['feature-flags'];
    }

    /**
     * Checks if feature flag is enabled
     * @param {string} flag - Feature flag name
     */
  }, {
    key: "isFeatureFlagEnabled",
    value: function isFeatureFlagEnabled(flag) {
      var value = this.getFeatureFlagValue(flag);
      return value === true || value === 'true';
    }

    /**
     * Get feature flag by name
     * @param {string} flag - Feature flag name
     */
  }, {
    key: "getFeatureFlagValue",
    value: function getFeatureFlagValue(flag) {
      var value = this.configuration['feature-flags'][flag];
      var key = "featureFlag:".concat(flag);
      if (localStorage && localStorage.getItem(key)) {
        value = localStorage.getItem(key);
        Logger.info("Overwritten feature-flag usage for '".concat(flag, "': ").concat(value));
      }
      return value;
    }

    /**
     * Get feature flag by name
     * @param {string} flag - Feature flag name
     * @param {string} value - Compared against value
     */
  }, {
    key: "isFeatureFlagEqual",
    value: function isFeatureFlagEqual(flag, value) {
      return this.getFeatureFlagValue(flag) === value;
    }

    /**
     * Get telemetry flag
     */
  }, {
    key: "getTelemetry",
    value: function getTelemetry() {
      return this.configuration.services.telemetry !== undefined ? this.configuration.services.telemetry : true;
    }
  }, {
    key: "validateConfigurationLoaded",
    value: function validateConfigurationLoaded(componentName) {
      var configured = this.configuration !== undefined && this.configuration.services !== undefined && this.configuration['feature-flags'] !== undefined;
      if (!configured) {
        Logger.info("\"Unable to render ".concat(componentName, ". Please ensure the the WDHFeatureB2BShopInitializationSpot\n      is present on the page before any other B2B shop components and the configuration service is properly configured.\""));
      }

      /** If Shop is disabled, then don't render component and finish silently */
      if (this.configuration !== undefined && this.configuration.enabled === false) {
        return false;
      }
      return configured;
    }

    /**
     * Checks if configuration is properly initialized
     */
  }, {
    key: "isConfigured",
    value: function isConfigured() {
      return this.configuration !== undefined && this.configuration.enabled !== false && this.configuration.services !== undefined && this.configuration['feature-flags'] !== undefined;
    }
  }]);
}();
var ConfigurationManager = new ConfigurationMgr();
export default ConfigurationManager;